import React, {useCallback, useContext, useEffect, useMemo, useState} from 'react';
import axios, {AxiosInstance, AxiosRequestConfig, InternalAxiosRequestConfig} from 'axios';
import useAuth from '../utils/AuthContext';
import {Config} from '../config';
import Qs from 'qs';

export interface IAxiosContext {
  instance: AxiosInstance;
  defaultErrorHandle?: (error: Error) => any;
  axiosConfig: AxiosRequestConfig;
}
const AxiosContext = React.createContext<IAxiosContext>({} as any);

export interface IAxiosProviderProps {
  children?: any;
  onResponseReject?: (error: any) => Promise<any>;
  onRequestFulfilled?: (config: InternalAxiosRequestConfig) => InternalAxiosRequestConfig;
  axiosConfig: AxiosRequestConfig;
  defaultErrorHandle?: (error: Error) => any;
}

export function useAxios(): IAxiosContext {
  return useContext(AxiosContext);
}

export default function AxiosProvider(props: IAxiosProviderProps): any {
  const auth = useAuth();
  const instance = useMemo(() => {
    const res = axios.create(props.axiosConfig);
    res.defaults.headers.common['Access-Control-Allow-Private-Network'] = true;
    res.interceptors.response.use(response => response, props.onResponseReject);
    res.interceptors.request.use(props.onRequestFulfilled);
    res.interceptors.request.use((config: any) => {
      config.headers = {
        ...config.headers,
        'Application-Version': Config.version,
        'Access-Control-Allow-Private-Network': true,
      };
      if (auth.isLogin) {
        config.headers = {...config.headers, 'Application-Token': auth.token};
      }
      return config;
    });
    res.interceptors.request.use(config => {
      config.paramsSerializer = (params: any) => Qs.stringify(params, {arrayFormat: 'repeat'});
      return config;
    });
    return res;
  }, [auth.token]);

  return (
    <AxiosContext.Provider
      value={{
        instance,
        defaultErrorHandle: props.defaultErrorHandle,
        axiosConfig: props.axiosConfig,
      }}>
      {props.children}
    </AxiosContext.Provider>
  );
}
